export default {
  name: "Modal",
  components: {},
  data() {
    return {
      
    }
  },
  methods: {},
  created() {},
  mounted() {}
};
